module.exports = __webpack_public_path__ + "assets/img/202111-5W.5191ae66.png";